import { render, staticRenderFns } from "./LocalePicker.vue?vue&type=template&id=2f95f764&scoped=true&lang=html&"
import script from "./LocalePicker.vue?vue&type=script&lang=js&"
export * from "./LocalePicker.vue?vue&type=script&lang=js&"
import style0 from "./LocalePicker.vue?vue&type=style&index=0&id=2f95f764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f95f764",
  null
  
)

export default component.exports